import { SERVER_METHODS, requestServer, API } from "./request";
import ApplicationError from "../utils/ApplicationError";

export const getContracts = async () => {
  // const path = "/contract/contracts";
  const path = "/flokk_contractappendix";
  try {
    let res = await requestServer(SERVER_METHODS.GET, path);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new ApplicationError(res.status, await res.json());
    }
  } catch (error) {
    if (error instanceof ApplicationError) throw error;
    else throw JSON.stringify({ code: "INT", info: "OTHER ERROR" });
  }
};

export const getBrandDetails = async () => {
  const path = "/flokk_branddetails";
  try {
    let res = await requestServer(SERVER_METHODS.GET, path);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new ApplicationError(res.status, await res.json());
    }
  } catch (error) {
    if (error instanceof ApplicationError) throw error;
    else throw JSON.stringify({ code: "INT", info: "OTHER ERROR" });
  }
};

export const getPaymentTerms = async () => {
  const path = "/flokk_paymentterms";
  try {
    let res = await requestServer(SERVER_METHODS.GET, path);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new ApplicationError(res.status, await res.json());
    }
  } catch (error) {
    if (error instanceof ApplicationError) throw error;
    else throw JSON.stringify({ code: "INT", info: "OTHER ERROR" });
  }
};

export const getContractAppendices = async (contractId) => {
  const path = "/flokk_appendixdetailsall?contract_id=" + contractId;
  try {
    let res = await requestServer(SERVER_METHODS.GET, path);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new ApplicationError(res.status, await res.json());
    }
  } catch (error) {
    if (error instanceof ApplicationError) throw error;
    else throw JSON.stringify({ code: "INT", info: "OTHER ERROR" });
  }
};

export const postContractAppendix = async (appendixPayload) => {
  console.log("In 1", appendixPayload);
  // const path = "/contract/brand-details";
  const path = "/action/flokkSaveAppendix";
  try {
    let res = await requestServer(SERVER_METHODS.POST, path, appendixPayload);
    console.log(res);
    if (res.status === 200) {
      res = await res.json();
      console.log(res);
      return res;
    } else {
      console.log(res.status);
      throw new ApplicationError(res.status, await res.json());
    }
  } catch (error) {
    console.log(error);
    if (error instanceof ApplicationError) throw error;
    else throw JSON.stringify({ code: "INT", info: "OTHER ERROR" });
  }
};

export const submitAppendixForApproval = async (appendixPayload) => {
  // const path = "/contract/appendix-negotiated";
  const path = "/action/flokkNegotiatedAppendix";
  try {
    let res = await requestServer(SERVER_METHODS.POST, path, appendixPayload);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new ApplicationError(res.status, await res.json());
    }
  } catch (error) {
    if (error instanceof ApplicationError) throw error;
    else throw JSON.stringify({ code: "INT", info: "OTHER ERROR" });
  }
};

export const approveAppendix = async (appendixPayload) => {
  // const path = "/contract/appendix-approved";
  const path = "/action/flokkConfirmAppendix";
  try {
    let res = await requestServer(SERVER_METHODS.POST, path, appendixPayload);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new ApplicationError(res.status, await res.json());
    }
  } catch (error) {
    if (error instanceof ApplicationError) throw error;
    else throw JSON.stringify({ code: "INT", info: "OTHER ERROR" });
  }
};

export const rejectAppendix = async (appendixPayload) => {
  // const path = "/contract/appendix-rejected";
  const path = "/action/flokkRejectAppendix";
  try {
    let res = await requestServer(SERVER_METHODS.POST, path, appendixPayload);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new ApplicationError(res.status, await res.json());
    }
  } catch (error) {
    if (error instanceof ApplicationError) throw error;
    else throw JSON.stringify({ code: "INT", info: "OTHER ERROR" });
  }
};

export const getContract = async (contractObj) => {
  const path = "/contract/contract";
  try {
    let res = await requestServer(SERVER_METHODS.POST, path, contractObj);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new ApplicationError(res.status, await res.json());
    }
  } catch (error) {
    if (error instanceof ApplicationError) throw error;
    else throw JSON.stringify({ code: "INT", info: "OTHER ERROR" });
  }
};

export const resetContract = async (contractId) => {
  const path = "/action/flokkResetContract?id=" + contractId;
  try {
    let res = await requestServer(SERVER_METHODS.POST, path);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new ApplicationError(res.status, await res.json());
    }
  } catch (error) {
    if (error instanceof ApplicationError) throw error;
    else throw JSON.stringify({ code: "INT", info: "OTHER ERROR" });
  }
};

export const downloadCSVReport = async () => {
  const path = "/contract/full_report";
  try {
    let res = await requestServer(SERVER_METHODS.GET, path, {});
    if (res.status === 200) {
      let response = await res.json();
      let ieEDGE = navigator.userAgent.match(/Edge/g);
      let ie = navigator.userAgent.match(/.NET/g); // IE 11+
      let oldIE = navigator.userAgent.match(/MSIE/g);

      let blob = new Blob(["\ufeff", response.body], { type: "text/csv" });

      if (ie || oldIE || ieEDGE) {
        window.navigator.msSaveBlob(response.body, response.fileName);
      } else {
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = response.fileName;
        link.click();

        /*setTimeout(function () {
              window.URL.revokeObjectURL(url);
            }, 0);*/
      }
    } else {
      throw new ApplicationError(res.status, await res.json());
    }
  } catch (error) {
    console.log(error);
    if (error instanceof ApplicationError) throw error;
    else throw JSON.stringify({ code: "INT", info: "OTHER ERROR" });
  }
};

export const getTickets = async (trader_company_id, page) => {
  const res = await API.get("/flokk_tickets", {
    params: {
      limit: 10,
      offset: page * 10,
      company_id: trader_company_id,
    },
  });
  console.log("res", res);
  return res.data;
};

export const getDomain = async (trader_company_id) => {
  const res = await API.get("/flokk_onlinedomain", {
    params: {
      company_id: trader_company_id,
    },
  });
  return res.data;
};

export const saveDomain = async (trader_company_id, data) => {
  const res = await API.post("/action/flokkSaveDomain", data, {
    params: {
      company_id: trader_company_id,
    },
  });
  return res.data;
};

export const getElements = async (menu_id) => {
  const res = await API.post("/proxy/element/get-elements", undefined, {
    params: {
      menu_id,
      limit: 0,
    },
  });
  return res.data.metaData;
};

export const getKeyOptions = async (meta_id) => {
  const res = await API.get(`/key_detail/${meta_id}`);
  return res.data;
};
